import Banner from 'components/Content/Banner/Banner';
import { withBannerProps } from 'viewModel/content/banner/withBannerProps';

export default withBannerProps(Banner);
